// extracted by mini-css-extract-plugin
export default {"description":"style_description__r7kum","fade-in":"style_fade-in__WSETd","top":"style_top__vyrsj","image":"style_image__bCtCE"};